'use strict';

const base = module.superModule || {};
const baseAppendQueryParams = base.appendQueryParams;

/**
 * Replaces query param values in a URL, or adds them if they don't exist
 *
 * @param {string} target An URL endpoint with or without query params
 *     e.g. http://someresource or http://someresource?xyz=123
 * @param {Object} params Object of query params to replace on the URL
 *     e.g. { var1: val1, var2: val2 }
 * @return {string} Target URL with query param values replaced
 */
base.replaceUrlParams = function (url, params) {
  let resultUrl = url.toString();

  Object.keys(params).forEach(function (paramName) {
    let paramValue = params[paramName];
    let paramPattern = '(&|\\?)' + paramName + '=[^&?]+';
    let newParamPair = paramName + '=' + encodeURIComponent(paramValue);

    if (resultUrl.search(paramPattern) >= 0) {
      let newParamPart = '$1' + newParamPair;

      resultUrl = resultUrl.replace(new RegExp(paramPattern), newParamPart);
    } else {
      let separator = resultUrl.indexOf('?') >= 0 ? '&' : '?';

      resultUrl = resultUrl + separator + newParamPair;
    }
  });

  return resultUrl;
};

/**
 * The SFRA QueryString class cannot handle URLs without a query string (that don't contain a '?'),
 * returning an object that contains an entry whose key is the URL, and whose value is undefined.
 * The base appendQueryParams logic ignores this case, whichi leads to broken search permalinks
 * when storefront category URLs are enabled
 *
 * This function intercepts such cases and calls replaceUrlParams isntead, which handles them correctly
 *
 * @param {string} target - An URL endpoint with or without query params
 *     e.g. http://someresource or http://someresource?xyz=123
 * @param {Object|string[]} queryParamsToAppend - Object or list of query params strings with or
 *     without resource path prepended, where resource path is discarded
 *     e.g., ['xyz=123'] or ['http://someresource?xyz=123'] or { var1: val1, var2: val2 }
 * @return {string} - Target URL appended with query params from sourceQueryString
 */
base.appendQueryParams = function (target, queryParamsToAppend) {
  if (Array.isArray(queryParamsToAppend) || target.indexOf('?') >= 0) {
    return baseAppendQueryParams.call(null, target, queryParamsToAppend);
  }

  return base.replaceUrlParams(target, queryParamsToAppend);
};

base.parseQueryString = function (queryString) {
  if (queryString) {
    return queryString.split('&').reduce(function (obj, query) {
      const splitQuery = query.split('=');
      obj[splitQuery[0]] = splitQuery[1];
      return obj;
    }, {});
  }
  return {};
};

module.exports = base;
